import React, {useEffect, useMemo, useState} from 'react';
import useKnowledgeTest, {KnowledgeTestType} from '../../../hooks/apis/useKnowledgeTest';
import {Breadcrumb, Button, Card, Checkbox, Col, Divider, Row, Skeleton} from 'antd';
import Flex from '../../../components/Flex';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import QuickRouter from '../../../utils/QuickRouter';
import Paragraph from 'antd/lib/typography/Paragraph';
import useKnowledgeSubmission from '../../../hooks/apis/useKnowledgeSubmission';
import QRCode from 'qrcode.react';
import useAuth from '../../../utils/AuthContext';
import {useParams} from 'react-router-dom';
import {useMount} from 'react-use';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import useQuickRouter from '../../../utils/QuickRouter';

export default function KnowledgeTestResultPage() {
  const auth = useAuth();
  const queryTestState = useKnowledgeTest.queryById();
  const queryHistory = useKnowledgeTest.queryHistoryByTestId();
  const queryHistoryList = useKnowledgeTest.queryHistory();
  const querySubmission = useKnowledgeSubmission.queryById();
  const params = useParams() as {id?: string; userId?: string};
  const testId = parseInt(params?.id || '');
  const test = queryTestState.data;
  const history = queryHistory.data;
  const submission = querySubmission.data;
  const routeQueryUserId = params?.userId || '';
  const quickRouter = useQuickRouter();

  function refresh() {
    queryTestState
      .request({id: testId})
      .then(() => {
        queryHistory
          .request({testId, userId: parseInt(routeQueryUserId)})
          .then(res => {
            queryHistoryList.request({testId}).catch(CommonApiErrorHandler);
            if (res.bestTimeUsageSubmissionId) {
              querySubmission.request({id: res.bestTimeUsageSubmissionId}).catch(CommonApiErrorHandler);
            }
          })
          .catch(CommonApiErrorHandler);
      })
      .catch(CommonApiErrorHandler);
  }

  useMount(() => {
    refresh();
  });

  const result = useMemo(() => {
    const result = {
      isFound: false,
      bestScoreGet: 0,
      timeUsage: 0,
      totalRecordCount: 0,
      bestScoreGetRank: 0,
      timeUsageRank: 0,
    };
    const history = queryHistory.data;
    const historyList = queryHistoryList.data;
    if (!history || !historyList || !submission) return result;
    result.isFound = true;

    result.bestScoreGet = history.bestScoreGet;
    result.timeUsage = history.bestTimeUsage;
    result.totalRecordCount = historyList.length;

    historyList.sort((a, b) => b.bestScoreGet - a.bestScoreGet);
    result.bestScoreGetRank = historyList.findIndex(i => i.submitter.id === history.submitter.id) + 1;

    historyList.sort((a, b) => a.bestTimeUsage - b.bestTimeUsage);
    result.timeUsageRank = historyList.findIndex(i => i.submitter.id === history.submitter.id) + 1;
    return result;
  }, [queryTestState.data, queryHistoryList.data, queryHistory.data, querySubmission.data]);

  return (
    <Flex justify={'center'}>
      <div style={{width: 700}}>
        <Breadcrumb className={'mb-md'}>
          <Breadcrumb.Item>
            <a onClick={quickRouter.index}>首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => quickRouter.contestDetail(test?.contest?.id || 0)}>活动首页</a>
          </Breadcrumb.Item>
        </Breadcrumb>
        <Card style={{width: 700}}>
          <Skeleton loading={queryTestState.loading}>
            {!result.isFound && <div>未查询到成绩</div>}
            {test && history && submission && result.isFound && (
              <Flex direction={'column'} align={'center'}>
                <Title level={4}>{test.contest.name}</Title>
                <Title level={2} style={{marginBottom: 15, marginTop: 0}}>
                  {KnowledgeTestType[test.type]} 成绩
                </Title>
                <Divider />
                <Flex>
                  <Flex align={'center'} justify={'center'} style={{marginRight: 30}}>
                    <img src={'/images/graduation.svg'} alt={'graduation'} style={{width: 150}} />
                  </Flex>
                  <div style={{textAlign: 'left', width: '100%', padding: '0 20px'}}>
                    <Paragraph strong>{history.submitter.legalName} 同学：</Paragraph>
                    <Paragraph>
                      答对 {submission.rightSingleCount} 道单选题，正确率 {((submission.rightSingleCount / submission.totalSingleCount) * 100).toFixed()}%；
                      <br />
                      答对 {submission.rightMultiCount} 道复选题，正确率 {((submission.rightMultiCount / submission.totalMultiCount) * 100).toFixed()}%；
                    </Paragraph>
                    <Paragraph style={{fontSize: 18}}>
                      答题速度为 {(result.timeUsage / 60).toFixed()} 分 {Math.floor(result.timeUsage) % 60} 秒
                      <br />
                      当前排名为第 {result.timeUsageRank} 名 / 共 {result.totalRecordCount} 名！
                    </Paragraph>
                    <Paragraph style={{fontSize: 18}}>
                      答题得分为 {result.bestScoreGet} 分
                      <br />
                      当前排名为第 {result.bestScoreGetRank} 名 / 共 {result.totalRecordCount} 名！
                    </Paragraph>
                    <Paragraph>本排名未包含仍在比赛中的选手、且未经人工审核，仅供参考。 竞赛全部结束后、排名经组委会审核后方为正式有效。</Paragraph>
                  </div>
                </Flex>
                <div style={{textAlign: 'center', marginTop: 20, width: '100%'}}>
                  <QRCode size={80} value={window.location.href} />
                </div>
              </Flex>
            )}
          </Skeleton>
        </Card>
      </div>
    </Flex>
  );
}
